import styles from './Q_BlurEffect.module.css';
import cn from 'classnames';

interface Q_BlurEffectProps {
  yAxis?: 'top' | 'bottom';
  withBackground?: boolean;
  zIndex?: number;
}

export default function Q_BlurEffect({
  yAxis = 'bottom',
  withBackground = true,
  zIndex = -1,
}: Q_BlurEffectProps) {
  return (
    <div
      className={cn(styles.wrapper, { [styles.top]: yAxis === 'top' })}
      style={{ zIndex }}
    >
      {withBackground && <div className={styles.fill} />}
      <div className={styles.blur} />
    </div>
  );
}
